import onCustomisation from '@sections/customisations_data';
import { toggleItems } from '@src/components/toggleItems';

// Only one on the page
// We don't handle custo if several horizontal FAQ as not in the spec
// + no field created on Prismic to choose which FAQ
const faqHorizontal = document.querySelector('.basic-faq');

const applyPartnerBranding = function (data) {
  const logoPartner = `<img class="h-full" src="${data.header_img_url}">`;
  const nav = document.querySelector('header nav');
  nav.classList.add('partner-branded');
  const rightElement = nav.querySelector('.right-element');
  rightElement.innerHTML = logoPartner;
};

const addBrandingToFaq = function (data) {
  // Select item we want to customize
  const faqItemChosen = faqHorizontal.querySelector('.item-' + (data.faq_index - 1));
  // Change image and CTA url in action div
  const newImage = data.faq_img_url;
  faqItemChosen.querySelector('img').src = newImage;
  if (data.cta_url) {
    faqItemChosen.querySelector('.cta a').href = data.cta_url;
  }

  // Update partner name depending on old partner name
  const content = faqItemChosen.querySelector('.content-js').innerHTML;
  const newHTML = content.replace(data.old_partner_name, data.new_partner_name);
  faqItemChosen.querySelector('.content-js').innerHTML = newHTML;
  // Update url inside content if any
  if (data.new_partner_url) {
    faqItemChosen.querySelector('.content-js p a').href = data.new_partner_url;
  }
};

const hideFirstDropdown = function () {
  faqHorizontal.querySelectorAll('.toggle-item')[0].classList.remove("open");
  faqHorizontal.querySelectorAll('.h-0')[0].style.height = '0px';
  faqHorizontal.querySelector('.item-0').style.contentVisibility += 'hidden';
  faqHorizontal.querySelector('.item-0').style.borderBottomWidth += '0';
};

const addPromocodeHero = function (data) {
  const hero = document.querySelector(".hero-section")
  const cta = hero.querySelector(".primary")
  let first = data.promo_code_hero.split('[')[0]
  let code = data.promo_code_hero.split('[')[1]
  if (first && code) {
    cta.parentNode.insertAdjacentHTML('afterBegin', `<div class="promo-partner"><p>${first}<span>${code}</span></p></div>`)
  }
}

onCustomisation('partner_branding', function (data) {
  if (window.location.href.includes(data.matching_params)) {
    applyPartnerBranding(data);
    if(data.promo_code_hero) {
      addPromocodeHero(data);
    }
    if (data.faq_img_url) addBrandingToFaq(data);
    if (data.hide_first_dropdown)  {
      setTimeout(hideFirstDropdown, 1);
    }
  }
});
